import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-status-h",
  "use": "icon-status-h-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-status-h\">\r\n  <defs>\r\n    <style>\r\n      #icon-status-h .cls-1 {\r\n        fill: #909399;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-status-h_提示\" class=\"cls-1\" d=\"M1058,214a7,7,0,1,1,7-7A7.016,7.016,0,0,1,1058,214Zm0-13.173a6.174,6.174,0,1,0,6.18,6.174A6.183,6.183,0,0,0,1058,200.825Zm0,7.765a0.418,0.418,0,0,1-.42-0.413v-4.712a0.418,0.418,0,0,1,.42-0.413,0.409,0.409,0,0,1,.41.413v4.712A0.409,0.409,0,0,1,1058,208.59Zm0,2.355a0.413,0.413,0,0,1,0-.825h0A0.413,0.413,0,0,1,1058,210.945Z\" transform=\"translate(-1051 -200)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/status-h.svg
// module id = 0/53
// module chunks = 127